import { marketAsyncComponent } from '@/utils/asyncComponent';

export default marketAsyncComponent('vm-tree-org', '0.0.1', { crossorigin: 'anonymous' });
